import React from 'react';

import { Card } from 'src/component/ds/ui/card';
import { Pill } from 'src/component/ds/ui/pill';
import { Skeleton } from 'src/component/ds/ui/skeleton';
import { cn } from 'src/component/ds/utils';
import { useTranslation } from 'src/i18n';

export interface DeviceSummaryBarProps {
  /** Devices under a lock-out/tag-out note. */
  loto?: number;
  offline?: number;
  alarming?: number;
  /** Every circuit matching the current filters; the "of" in "8 of 129". */
  totalDevices?: number;
  forcedOn?: number;
  onLotoClick?: () => void;
  onOfflineClick?: () => void;
  onAlarmingClick?: () => void;
  onForcedOnClick?: () => void;
  /** Swaps the pills for skeletons while the counts are being fetched. */
  loading?: boolean;
  className?: string;
}

const SKELETON_WIDTHS = ['ds-w-[85px]', 'ds-w-[93px]', 'ds-w-[124px]', 'ds-w-[110px]'];


export default function DeviceSummaryBar ({
  loto = 0,
  offline = 0,
  alarming = 0,
  totalDevices = 0,
  forcedOn = 0,
  onLotoClick,
  onOfflineClick,
  onAlarmingClick,
  onForcedOnClick,
  loading = false,
  className
}: DeviceSummaryBarProps) {
  const { t } = useTranslation();

  return (
    <Card className={cn('ds-shadow-ds-xs', className)} data-testid='device-summary-bar'>
      <div className='ds-flex ds-items-center ds-gap-2 ds-py-[14.5px] ds-pl-4 ds-pr-[19px]'>
        <p className='ds-text-ds-mini ds-font-bold ds-text-muted-foreground ds-whitespace-nowrap'>
          {t('devices.devices')}
        </p>

        {loading
          ? SKELETON_WIDTHS.map((width) => (
            <Skeleton
              key={width}
              className={cn('ds-h-ds-xs ds-rounded-full', width)}
              data-testid='device-summary-skeleton'
            />
          ))
          : (
            <>
              <Pill
                label={t('dashboard.loto')}
                value={loto}
                testId='device-summary-loto'
                onClick={onLotoClick}
              />
              <Pill
                label={t('common.offline')}
                value={offline}
                testId='device-summary-offline'
                onClick={onOfflineClick}
              />
              <Pill
                label={t('dashboard.alarming')}
                value={`${alarming}/${totalDevices}`}
                testId='device-summary-alarming'
                onClick={onAlarmingClick}
              />
              <Pill
                label={t('dashboard.forcedOn')}
                value={forcedOn}
                testId='device-summary-forced-on'
                onClick={onForcedOnClick}
              />
            </>
          )}
      </div>
    </Card>
  );
}
